import { AlertCircleOutline } from '@byway/icons';
import styles from './TripDateError.module.css';

type TripDateErrorProps = {
  message: string;
};

export const TripDateError = ({ message }: Readonly<TripDateErrorProps>) => (
  <div role="alert" className={styles.dateError}>
    <span className={styles.dateErrorIcon}>
      <AlertCircleOutline decorative size="scale" />
    </span>
    <p className={styles.dateErrorBody}>{message}</p>
  </div>
);
